import React from 'react';
import Slider from "@ant-design/react-slick";
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './bannermain.css'; // Import your CSS file
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


export default function BannerMain() {
  var settings = {
    dots: true,
    fade: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false
  };
  return (
    <div className="banner slider">
      <div className='slider-box'>
      <Slider {...settings}>
        {/* slide */}
          <div>
            <div className="container xl">
              <div className="row aic banner-content">
                <div className='col-8 col-lg-8 col-md-6 col-sm-12'>
                  <div className='b-text'>
                    <p className='fs-20 text-dark-grey fade-in'>Welcome To</p>
                    <h1 className='d-flex aic text-primary-color lh-1 alt-font fw-normal mb-15px fade-in'><span className='larg-jp'>JP </span>
                     <span> <span className='d-block fs-64'>International</span> <span className='d-block kanker text-dark-grey fs-58'>School Kanker</span>
                    </span> </h1>
                    <p className='mb-15px bounce trdelay-05'>is now proudly affiliated with</p>
                    <h2 className='fs-64 text-primary-color alt-font fw-normal lh-1 mb-20px bounce'>Sainik School</h2>
                    <p className='mb-25px bounce trdelay-1'>and becomes the <span className='fw-600 span-myclass'>first Sainik School</span> in the <span className='fw-600 span-myclass'>Bastar Division</span></p>
                    <div><Link className="dark-button me-10px bounce trdelay-15">About Us</Link>  <Link className="light-button bounce trdelay-15">Academics</Link></div>
                  </div>
                </div>
                <div className='col-4 col-lg-4 col-md-6 col-sm-12'>
                  <div className='b-img d-flex w-50 p-relative'>
                    <img className='center-img fade-in-sacale' src="/img/slider/slider-1/image-c.webp" alt="JPIS" />
                    <img className='left-move bounce trdelay-15' src="/img/slider/slider-1/image-vs1.webp" alt="JPIS" />
                    <img className='right-move bounce trdelay-15' src="/img/slider/slider-1/image-vs2.webp" alt="JPIS" />
                    <div className='left-img'>
                      <img className='fade-in-sacale trdelay-05'  src="/img/slider/slider-1/image-s1.webp" alt="JPIS" />
                      <img className='mt-6px fade-in-sacale trdelay-15' src="/img/slider/slider-1/image-l1.webp" alt="JPIS" />
                    </div>
                    <div className='right-img'>
                      <img className='fade-in-sacale trdelay-2' src="/img/slider/slider-1/image-l2.webp" alt="JPIS" />
                      <img className='mt-6px fade-in-sacale trdelay-1' src="/img/slider/slider-1/image-s2.webp" alt="JPIS" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           {/* slide-end */}
           {/* slide */}
          <div>
            <div className="container xl">
              <div className="row aic banner-content">
                <div className='col-8 col-lg-8 col-md-6 col-sm-12'>
                  <div className='b-text'>
                    <p className='fs-20 text-dark-grey fade-in'>Welcome To</p>
                    <h1 className='d-flex aic text-primary-color lh-1 alt-font fw-normal mb-15px'><span className='larg-jp'>JP </span>
                     <span> <span className='d-block fs-64'>International</span> <span className='d-block kanker text-dark-grey fs-58 fade-in'>School Kanker</span>
                    </span> </h1>
                    <p className='mb-15px bounce trdelay-05'>is now proudly affiliated with</p>
                    <h2 className='fs-64 text-primary-color alt-font fw-normal lh-1 mb-20px bounce'>Sainik School</h2>
                    <p className='mb-25px bounce trdelay-1'>and becomes the <span className='fw-600 span-myclass'>first Sainik School</span> in the <span className='fw-600 span-myclass'>Bastar Division</span></p>
                    <div><Link className="dark-button me-10px bounce trdelay-15">About Us</Link>  <Link className="light-button bounce trdelay-15">Academics</Link></div>
                  </div>
                </div>
                <div className='col-4 col-lg-4 col-md-6 col-sm-12'>
                  <div className='b-img d-flex w-50 p-relative'>
                    <img className='center-img fade-in-sacale' src="/img/slider/slider-1/image-c.webp" alt="JPIS" />
                    <img className='left-move bounce trdelay-15' src="/img/slider/slider-1/image-vs1.webp" alt="JPIS" />
                    <img className='right-move bounce trdelay-15' src="/img/slider/slider-1/image-vs2.webp" alt="JPIS" />
                    <div className='left-img'>
                      <img className='fade-in-sacale trdelay-05'  src="/img/slider/slider-1/image-s1.webp" alt="JPIS" />
                      <img className='mt-6px fade-in-sacale trdelay-15' src="/img/slider/slider-1/image-l1.webp" alt="JPIS" />
                    </div>
                    <div className='right-img'>
                      <img className='fade-in-sacale trdelay-2' src="/img/slider/slider-1/image-l2.webp" alt="JPIS" />
                      <img className='mt-6px fade-in-sacale trdelay-1' src="/img/slider/slider-1/image-s2.webp" alt="JPIS" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           {/* slide-end */}
           {/* slide */}
          <div>
            <div className="container xl">
              <div className="row aic banner-content">
                <div className='col-8 col-lg-8 col-md-6 col-sm-12'>
                  <div className='b-text'>
                    <p className='fs-20 text-dark-grey bounce'>Welcome To</p>
                    <h1 className='d-flex aic text-primary-color lh-1 alt-font fw-normal mb-15px fade-in'><span className='larg-jp'>JP </span>
                     <span> <span className='d-block fs-64'>International</span> <span className='d-block kanker text-dark-grey fs-58 '>School Kanker</span>
                    </span> </h1>
                    <p className='mb-15px bounce trdelay-05'>is now proudly affiliated with</p>
                    <h2 className='fs-64 text-primary-color alt-font fw-normal lh-1 mb-20px bounce'>Sainik School</h2>
                    <p className='mb-25px bounce trdelay-1'>and becomes the <span className='fw-600 span-myclass'>first Sainik School</span> in the <span className='fw-600 span-myclass'>Bastar Division</span> </p>
                    <div><Link className="dark-button me-10px bounce trdelay-15">About Us</Link>  <Link className="light-button bounce trdelay-15">Academics</Link></div>
                  </div>
                </div>
                <div className='col-4 col-lg-4 col-md-6 col-sm-12'>
                  <div className='b-img d-flex w-50 p-relative'>
                    <img className='center-img fade-in-sacale' src="/img/slider/slider-1/image-c.webp" alt="JPIS" />
                    <img className='left-move bounce trdelay-15' src="/img/slider/slider-1/image-vs1.webp" alt="JPIS" />
                    <img className='right-move bounce trdelay-15' src="/img/slider/slider-1/image-vs2.webp" alt="JPIS" />
                    <div className='left-img'>
                      <img className='fade-in-sacale trdelay-05'  src="/img/slider/slider-1/image-s1.webp" alt="JPIS" />
                      <img className='mt-6px fade-in-sacale trdelay-15' src="/img/slider/slider-1/image-l1.webp" alt="JPIS" />
                    </div>
                    <div className='right-img'>
                      <img className='fade-in-sacale trdelay-2' src="/img/slider/slider-1/image-l2.webp" alt="JPIS" />
                      <img className='mt-6px fade-in-sacale trdelay-1' src="/img/slider/slider-1/image-s2.webp" alt="JPIS" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           {/* slide-end */}
              
     
      </Slider>
      </div>
    </div>
  );
}